import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext } from "react";
import { useSocialLogin } from "./talons/useSocialLogin";
import { useSignInEvent } from "./talons/useSignInEvent";
var AmSocialLoginContext = createContext();
var {
  Provider
} = AmSocialLoginContext;
var AmSocialLoginProvider = props => {
  var {
    children
  } = props;
  var talonProps = useSocialLogin();
  var {
    error,
    needRedirect,
    redirectUrl,
    handleErrors
  } = talonProps;
  var {
    isBusy
  } = useSignInEvent({
    needRedirect,
    redirectUrl,
    handleErrors
  });
  if (error) {
    console.error(error);
    console.log("Check if Amasty modules has been installed!");
  }
  var contextValue = _objectSpread(_objectSpread({}, talonProps), {}, {
    isBusy
  });
  return /*#__PURE__*/React.createElement(Provider, {
    value: contextValue
  }, children);
};
export default AmSocialLoginProvider;
export var useSocialLoginContext = () => useContext(AmSocialLoginContext);